import { injectIntl } from 'react-intl';

import BorderControlRequirements from './BorderControlRequirements';

export default injectIntl(BorderControlRequirements);
